import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'search-knowledge-base' as const;

// Define the input schema with convenient zod object
const argumentZod = z.object({
  query: z.string().describe('A question or topic to search for.'),
});

export const searchKnowledgeBaseManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Search knowledge base',
  prettyStatus: {
    executed: 'Searched knowledge base',
    executing: 'Searching knowledge base',
    failed: 'Failed to search knowledge base',
  },
  llmTool: {
    name: toolName,
    description:
      "Searches the Webflow University knowledge base for relevant information to accomplish the user's request inside of Webflow.",
    inputSchema: argumentZod,
  },
  type: 'server',
  confirmBeforeExecuting: false,
  isConcurrencySafe: () => true,
  isReadOnly: () => true,
});
